
"use client"
export const ValidateName = (names: any) => {
    if (names) {
        const name = names.split(",")
        return name[1].trim()
    } else {
        return ""
    }
}


export const ValidateApellidoPaterno = (names: string) => {
    const special_tokens = ["de", "sal", "sam", "del", "los", "las", "san", "santa", "la", "martinez"]
    if (names) {
        const name = names.split(",");
        const apellidos = name[0].split(" ");

        if (apellidos.length === 2) {
            return apellidos[0];
        }

        if (apellidos.length === 3) {

            const existe = special_tokens.includes(apellidos[0].toLowerCase());
            if (existe) {
          
                return apellidos.slice(0, -1).join(" ");
            } else {
                return apellidos.slice(0, 1).join(" ");
            }
        }

        if (apellidos.length === 4) {
            // Si comienza por una palabra especial
      
            const existe = special_tokens.includes(apellidos[0].toLowerCase());
            if (existe) {
                return apellidos.slice(0, -1).join(" ");
            }
            return apellidos[0].toString()
        }

        if (apellidos.length > 4) {
            const existe = special_tokens.includes(apellidos[0].toLowerCase());
            if (existe) {
                return apellidos.slice(0, 3).join(" ");
            }
            return apellidos.slice(-3).join(" ")
        }

    } else {
        return "";
    }
};

export const ValidateApellidoMaterno = (names: string) => {
    const special_tokens = ["de", "sal", "sam", "del", "los", "las", "san", "santa", "la", "martinez", "sal"]
    if (names) {
        const name = names.split(",");
        const apellidos = name[0].split(" ");

        if (apellidos.length === 2) {
            return apellidos[1];
        }

        if (apellidos.length === 3) {
            const existe = special_tokens.includes(apellidos[0].toLowerCase());
            if (existe) {
                return apellidos[apellidos.length - 1].toString();
            }
            return apellidos.slice(-2).join(" ")

        }

        if (apellidos.length === 4) {
     
            // Si comienza por una palabra especial
            const existe = special_tokens.includes(apellidos[0].toLowerCase());
            if (existe) {
                return apellidos[apellidos.length - 1].toString();
            }
            return apellidos.slice(-3).join(" ")
        }

        if (apellidos.length > 4) {
            const existe = special_tokens.includes(apellidos[0].toLowerCase());
            if (existe) {
                return apellidos.slice(apellidos.length - 3).join(" ");
            }
            return apellidos.slice(0, 3).join(" ")
        }

    }
    else {
        return "";
    }
}
